import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChevronLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"chevron-left"} maskId="square-filled-radius-0-stroke-1-IconChevronLeft"><path fillRule="evenodd" clipRule="evenodd" d="M15.7072 4.00008L7.70718 12.0001L15.7072 20.0001L15.0001 20.7072L6.29297 12.0001L15.0001 3.29297L15.7072 4.00008Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconChevronLeft;
